<template>
<div id="signup" class="signup">
  <section class="container">
    <div class="row">
      <div class="form-title">{{ $t('signup.signup.title') }}</div>
    </div>
    <div class="row">
      <div class="register-step">
        <div class="step-item step1 on">Account information</div>
        <div class="step-item step2 on">Confirmation</div>
        <div class="step-item step3 on">Payment</div>
        <div class="step-item step4">Complate</div>
      </div>
      <div class="register-step-bg step3"></div>
    </div>
    <div class="row subscribe-box">
      <div class="form-group subscribe plan">
    
        <div class="price-list" v-for="(plankey, plantype) in planOptions">
          <div class="plan-box" v-if="plantype=='month'" :class="{ 'selected' : selectedPlanType == 'month' }">
            <div class="plan-name-box">
              <div class="plan-status select"></div>
              <div class="plan-name">Monthly plan</div>
            </div>
            <div class="plan-price">
                <span>¥</span>1,500
            </div>
          </div>
        </div>
      </div>
      <div class="form-group subscribe">
        <label for="card-element-number" class="form-label">{{ $t('signup.signup.label_cardnumber') }}</label>
        <div id="card-element-number"></div>
      </div>
      <div class="form-group subscribe flex">
        <div class="form-group form-group-half">
          <label for="card-element-number" class="form-label">{{ $t('signup.signup.label_expirationdate') }}</label>
          <div id="card-element-expiry"></div>
        </div>
        <div class="form-group form-group-half">
          <label for="card-element-number" class="form-label">{{ $t('signup.signup.label_cvc') }}</label>
          <div id="card-element-cvc"></div>
        </div>
      </div>
      <div class="form-group">
        <button class="button button-primary next" @click="subscribe">{{ $t('common.button.payment') }}</button>
        <div v-if="isSubscribed">subscribed !!!</div>
      </div>
    </div>
  </section>
  
  <!-- FlashMessage -->
  <FlashMessage></FlashMessage>
  <!-- /FlashMessage -->
</div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {api} from "../../config";

  import { StripeElementCard } from '@vue-stripe/vue-stripe';

  export default {
    components: {
      StripeElementCard,
    },
    data() {
      return {
        stripe: null,
        stripeCardNumber: null,
        stripeCardExpiry: null,
        stripeCardCvc: null,
        publicKey: null,
        secretKey: null,
        status: '',
        cardHolderName: '',
        details: {},
        plan: '',
        planOptions: {},
        intentToken: null
      };
    },
    created () {
      this.publicKey = window.config.stripe.key
      this.secretKey = window.config.stripe.secret
      this.planOptions = window.config.stripe.plans
      
      this.plan = this.planOptions['month']
    },
    async mounted() {
      
      this.includeStripe('js.stripe.com/v3/', function(){
          this.configureStripe();
          this.loadIntent();
      }.bind(this) );
      
    },
    computed: {
      ...mapGetters([
        'selectedLanguage'
      ]),
      isSubscribed() {
          return (this.status === 'subscribed' || this.status === 'cancelled');
      },
      isCancelled() {
          return (this.status === 'cancelled');
      },
      selectedPlanType() {
        
        if(!this.planOptions) return null
        
        let thisPlanType = null;
        
        if(this.planOptions['month'] == this.plan) {
          thisPlanType = 'month'
        }
        return thisPlanType;
      }
    },
    methods: {
      /**
       * Includes Stripe.js dynamically
      **/
      includeStripe( URL, callback ){
          let documentTag = document, tag = 'script',
              object = documentTag.createElement(tag),
              scriptTag = documentTag.getElementsByTagName(tag)[0];
          object.src = '//' + URL;
          if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
          scriptTag.parentNode.insertBefore(object, scriptTag);
      },
      configureStripe(){
        
          this.loading = true;
          this.$store.dispatch('showLoading', true)
      
          this.stripe = Stripe( this.publicKey );

          this.elements = this.stripe.elements();
          this.stripeCardNumber = this.elements.create('cardNumber', {
                                  showIcon: true,
                                  placeholder: 'Card Number',
                                });
          this.stripeCardNumber.mount('#card-element-number');
          this.stripeCardExpiry = this.elements.create('cardExpiry');
          this.stripeCardExpiry.mount('#card-element-expiry');
          this.stripeCardCvc = this.elements.create('cardCvc');
          this.stripeCardCvc.mount('#card-element-cvc');
          
          axios.get(api.currentUser)
          .then((resp) => {
            this.authuser = resp.data;
            
            const url = '/subscription/status';
            axios.get(url)
                  .then(this.setStatus);
                  
                  
            this.loading = false;
            this.$store.dispatch('showLoading', false)
          });
      },
      loadIntent(){
        const url = '/subscription/getintent';
        axios.post(url)
            .then((response) => {
            this.intentToken = response.data;
        });
      },

      async subscribe(e) {
        let self = this;
        if(this.plan && this.plan.length) {
          this.$store.dispatch('showLoading', true)


          this.getPaymentMethod()
            .then(result => {
              if(result.error) {
                
                this.$store.dispatch('showLoading', false)
                
                this.flashMessage.show({
                  status: 'error',
                  title: result.error.message
                });
                
              } else {
                
                const url = '/subscription/subscribe';
                const params = {
                    payment_method: result.setupIntent.payment_method,
                    plan: this.plan
                };
                axios.post(url, params)
                  .then(response => {
                    if(response.data.status && response.data.status != 'unsubscribed') {
                      axios.get(api.currentUser)
                      .then((resp) => {
                          self.$store.dispatch('setAuthUser', resp.data)
                          self.$store.dispatch('showLoading', false)
                          self.$router.push({name: 'apps.purchase.finished'})
                      });
                    } else {
                      this.$store.dispatch('showLoading', false)
                    }
                  })
                  .catch(err => {
                    const errResponse = err.response
                    console.log(errResponse)
                    this.$store.dispatch('showLoading', false)
                    if(errResponse.data.error == 'IncompletePayment') {
                      window.location.href = errResponse.data.redirect_uri;
                    }
                  });
              }
            });
        }
      },
      cancel() {

          const url = '/subscription/cancel';
          axios.post(url)
              .then(this.setStatus);

      },
      resume() {

          const url = '/subscription/resume';
          axios.post(url)
              .then(this.setStatus);

      },
      async updateCard(e) {

          this.getPaymentMethod()
            .then(result => {
              if(result.error) {
                this.flashMessage.show({
                  status: 'error',
                  title: result.error.message
                });
              } else {
                const url = '/subscription/update_card';
                const params = { payment_method: result.setupIntent.payment_method };
                axios.post(url, params)
                    .then(response => {
                        location.reload();
                    });
              }
            })

      },
      setStatus(response) {

          this.status = response.data.status;
          this.details = response.data.details;

      },
      getPaymentMethod() {

          const clientSecret = this.intentToken.client_secret;
          return this.stripe.confirmCardSetup(
              clientSecret, {
                  payment_method: {
                      card: this.stripeCardNumber
                  }
              }
          );

      }
    }
  }
</script>
